import React from 'react';

import classnames from 'classnames';
import Button from 'shared/components/Button';
import Checkpoint from 'shared/components/Checkpoint';
import Price from 'shared/components/ChangePlanModal/components/Price';
import { PLAN_TYPES } from 'shared/components/ChangePlanModal/constants';

import styles from './styles.module.scss';

const ATTRIBUTES = [
  { text: 'Explore 7,500+ PropTech Investors', bold: true },
  { text: 'Analyse 9,300+ PropTech Investments', bold: true },
  { text: 'Understand 8,500+ PropTech Companies', bold: true },
  { text: 'Build Custom Queries Using 10+ Filters', bold: true },
  { text: 'Export Results to PDF', bold: true }
];

const PremiumPlan = ({
  currentPlanType,
  processingSubscription,
  handlePlanBtnClick,
  price
}) => {
  const planTypeValue = PLAN_TYPES.PREMIUM.value;
  const isCurrent = planTypeValue === currentPlanType;

  return (
    <div className={styles.planTypeContainer}>
      <div className={styles.typeLabel}>Data Explorer</div>
      <Price timeUnit="annum" price={price} />
      <div className={styles.planBtnContainer}>
        {isCurrent ? (
          <Button
            className={classnames(styles.planBtn, styles.borderBrandGreen)}
            color="white"
            onClick={() => handlePlanBtnClick(isCurrent, planTypeValue)}>
            Current Plan
          </Button>
        ) : (
          <Button
            className={styles.planBtn}
            color="brand-green"
            disabled={processingSubscription}
            onClick={() => handlePlanBtnClick(isCurrent, planTypeValue)}>
            {processingSubscription ? 'Processing' : 'Upgrade now'}
          </Button>
        )}
      </div>
      <div className={styles.attributes}>
        {ATTRIBUTES.map(item => (
          <Checkpoint
            iconClassNames={styles.icon}
            contentClassName={classnames(styles.content, {
              [styles.bold]: item.bold
            })}
            className={styles.attribute}>
            {item.text}
          </Checkpoint>
        ))}
      </div>
    </div>
  );
};

export default PremiumPlan;
